import moment from 'moment'

export default function (value, format) {
  const formatString = format || 'YYYY-MM-DDTHH:mm:ssZ'
  return moment(value).format(formatString)
}
